import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { Redirect } from 'react-router-dom';
import SidebarAdmin from '../layout/SidebarAdmin';
import { getAudios } from '../../actions/audio';
import AudioElement from './AudioElement';

const GestioneAudio = ({ auth: { user, loading }, alert, getAudios, audio: { audios }  }) => {

  const [audiosData, setAudiosData] = useState([]);


  useEffect(() => {
    getAudios()
  }, []);

  useEffect(() => {
		setAudiosData(audios)
	}, [audios]);

  if (user && user.ruolo !== 'admin') {
    return <Redirect to="/login" />;
  }

  return (loading ? <Spinner /> :
    <section className="fd-section wide">
      <div className="w-layout-blockcontainer fd-container null w-container">
        <div className="fd-wrap backend">
          <SidebarAdmin />
          <div>
            <div>
              <div className="w-layout-blockcontainer fd-container backend w-container">
                <div className="fd-wrap">
                  <div className="w100">
                    <div>
                      <h1 className="heading-3">Tutti il materiale</h1>
                    </div>
                    <div className="call-elenco audio-archivio">
                      {audiosData.map((el) => (
                        <AudioElement 
                          titoloAudio={el.titolo}
                          codiceAudio={el.codice}
                          descrizioneAudio={el.descrizione}
                          idAudio={el._id}
                          link={el.link}                       
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

GestioneAudio.propTypes = {
  auth: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  audio: PropTypes.func.isRequired,
  getAudios: PropTypes.func.isRequired

}

const mapStateToProps = state => ({
  auth: state.auth,
  alert: state.alert,
  audio: state.audio
});

export default connect(mapStateToProps, { getAudios })(GestioneAudio);